import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { sortByProperties } from 'donor-elf-web/lib/array-utils';
import TotalGivenExpectingReportModel from 'donor-elf-web/models/total-given-expecting-report';
import moment from 'moment';

export default class TotalGivenExpectingController extends Controller {
  @tracked contactExpectingItemsSortBy: {
    property: string;
    direction: string;
  } = {
    property: 'totalExpecting',
    direction: 'desc',
  };

  @tracked contactOverdueItemsSortBy: { property: string; direction: string } =
    {
      property: 'totalExpecting',
      direction: 'desc',
    };

  @tracked contactNoGiftItemsSortBy: { property: string; direction: string } = {
    property: 'totalExpecting',
    direction: 'desc',
  };

  get sortedContactExpectingItems() {
    return sortByProperties(this.model.contactExpectingItems, [
      `${this.contactExpectingItemsSortBy.property}:${this.contactExpectingItemsSortBy.direction}`,
    ]);
  }

  get sortedContactOverdueItems() {
    return sortByProperties(this.model.contactOverdueItems, [
      `${this.contactOverdueItemsSortBy.property}:${this.contactOverdueItemsSortBy.direction}`,
    ]);
  }

  get report(): TotalGivenExpectingReportModel {
    return this.model.givenExpectingReport;
  }

  get givenAmount() {
    return this.report.data?.given_amount;
  }

  get givenPercent() {
    return this.report.data?.given_percent;
  }

  get expectingAmount() {
    return this.report.data?.expected_amount;
  }

  get expectingPercent() {
    return this.report.data?.expected_percent;
  }

  get overdueAmount() {
    return this.report.data?.overdue_amount;
  }

  get overduePercent() {
    return this.report.data?.overdue_percent;
  }

  get totalAmount() {
    return this.report.data?.total_amount;
  }

  get totalPercent() {
    return this.report.data?.total_percent;
  }

  get leftAmount() {
    return this.report.data?.left_amount;
  }

  get leftPercent() {
    return this.report.data?.left_percent;
  }

  get givenFrom() {
    return moment(this.report.data?.start_date).format('YYYY-MM-DD');
  }

  get today() {
    return new Date();
  }

  get pledgesTo() {
    return this.report.goalDate;
  }

  @action
  sortContactExpectingItemsBy(sortProperty: string) {
    if (sortProperty === this.contactExpectingItemsSortBy.property) {
      this.contactExpectingItemsSortBy = {
        property: sortProperty,
        direction:
          this.contactExpectingItemsSortBy.direction === 'asc' ? 'desc' : 'asc',
      };
    } else {
      this.contactExpectingItemsSortBy = {
        property: sortProperty,
        direction: 'asc',
      };
    }
  }

  @action
  sortContactOverdueItemsBy(sortProperty: string) {
    if (sortProperty === this.contactOverdueItemsSortBy.property) {
      this.contactOverdueItemsSortBy = {
        property: sortProperty,
        direction:
          this.contactOverdueItemsSortBy.direction === 'asc' ? 'desc' : 'asc',
      };
    } else {
      this.contactOverdueItemsSortBy = {
        property: sortProperty,
        direction: 'asc',
      };
    }
  }
}
